<button
    qpxButton="unstyled"
    class="switch"
    role="switch"
    [attr.aria-label]="label() ?? null"
    [attr.aria-labelledby]="labelledBy() ?? null"
    [attr.aria-describedby]="describedBy() ?? null"
    [attr.aria-checked]="checked()"
    [attr.aria-disabled]="disabled() ? 'true' : null"
    [class.is-on]="checked()"
    (click)="onClick()"
>
    <span class="thumb"></span>
</button>
